import { render, staticRenderFns } from "./burger-menu.vue?vue&type=template&id=06e6e45c&"
import script from "./burger-menu.vue?vue&type=script&lang=js&"
export * from "./burger-menu.vue?vue&type=script&lang=js&"
import style0 from "./burger-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
